import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, StaticRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { BasketProvider } from "./contexts/BasketContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import StickyCta from "./components/StickyCta";
import WineBasket from "./components/WineBasket";
import Home from "./pages/Home";
import Zazitky from "./pages/Zazitky";
import ZazitekDetail from "./pages/ZazitekDetail";
import Ubytovani from "./pages/Ubytovani";
import ApartmentDetail from "./pages/ApartmentDetail";
import Vina from "./pages/Vina";
import Kontakt from "./pages/Kontakt";
import DarkovyPoukaz from "./pages/DarkovyPoukaz";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import { ObchodniPodminky, OchranaOsobnichUdaju, Cookies, Provozovatele } from "./pages/Legal";
import NotFound from "./pages/NotFound";

// Legacy /galerie address now redirects to the homepage gallery anchor.
function GalerieRedirect() {
  useEffect(() => {
    window.location.replace("/#galerie");
  }, []);
  return null;
}

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) { el.scrollIntoView({ behavior: "smooth", block: "start" }); return; }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function AppShell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Header />}
      {!isAdmin && <WineBasket />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/zazitky" element={<Zazitky />} />
        <Route path="/zazitky/vikend-s-degustaci" element={<Navigate to="/zazitky/rodinny-pobyt-na-jizni-morave" replace />} />
        <Route path="/zazitky/:slug" element={<ZazitekDetail />} />
        <Route path="/ubytovani" element={<Ubytovani />} />
        <Route path="/ubytovani/:slug" element={<ApartmentDetail />} />
        <Route path="/vina" element={<Vina />} />
        <Route path="/kontakt" element={<Kontakt />} />
        <Route path="/darkovy-poukaz" element={<DarkovyPoukaz />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/*" element={<Admin />} />
        <Route path="/obchodni-podminky" element={<ObchodniPodminky />} />
        <Route path="/ochrana-osobnich-udaju" element={<OchranaOsobnichUdaju />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/provozovatele" element={<Provozovatele />} />
        <Route path="/galerie" element={<GalerieRedirect />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <StickyCta />}
    </>
  );
}

// `location` is only passed by the build-time prerender script.
function App({ location }) {
  const shell = (
    <BasketProvider>
      <AppShell />
    </BasketProvider>
  );
  return location ? <StaticRouter location={location}>{shell}</StaticRouter> : <BrowserRouter>{shell}</BrowserRouter>;
}

export default App;
